import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import Header from 'components/Header';
import tableify from 'tableify';
import LoanDetails from './LoanDetails';
import _ from 'lodash';
import InfoBox from 'components/Organisations/InfoBox';
import { fetchOrganisation } from 'actions/organisations';

const styles = theme => ({
});

class XeroDetails extends React.Component {
  state = {
    tabIndex: 0,
  };

  componentWillMount = () => {
    this.props.dispatch(fetchOrganisation(this.props.organisationId))
  }

  handleChange = (event, tabIndex) => {
    this.setState({ tabIndex });
  };

  prettify = (data) => {
    var clone = JSON.parse(JSON.stringify(data))
    this.removeIdFields(clone);
    return tableify(clone);
  }

  unCamelCase = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
      .replace(/^./, function(str){ return str.toUpperCase(); })
  }

  removeIdFields = (data) => {
    for(var prop in data) {
      if (_.endsWith(prop, 'Id')) {
        delete data[prop];
      } else if (prop === 'name') {
        data[""] = data[prop];
        delete data[prop];
      } else if (typeof data[prop] === 'object') {
        this.removeIdFields(data[prop]);
      } else {
        data[this.unCamelCase(prop)] = data[prop] // uncamelcase attribute keys
        delete data[prop]
      }
    }
  }

  render = () => {
    const { tabIndex } = this.state;
    return (
      <div>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.tabIndex}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab label="Loan details" />
            <Tab label="Receipts" />
            <Tab label="Invoices" />
            <Tab label="Bank Transfer" />
          </Tabs>
        </AppBar>
        <br/>
        {
          tabIndex === 0 && (
            <div>
              <Grid container spacing={24}>
                <Grid item xs={6}>
                  <LoanDetails />
                </Grid>
                <Grid item xs={6}>
                  <InfoBox organisation={this.props.organisation} />
                </Grid>
              </Grid>
            </div>
          )
        }
        {
          tabIndex === 1 && (
            <div>
              <Header heading='Receipt' />
              <div class="xeroTable" dangerouslySetInnerHTML={{__html: this.prettify(this.props.xeroSnapshot.receipt) }} />
            </div>
          )
        }
        {
          tabIndex === 2 && (
            <div>
              <Header heading='Invoices' />
              <div class="xeroTable" dangerouslySetInnerHTML={{__html: this.prettify(this.props.xeroSnapshot.invoice) }} />
            </div>
          )
        }
        {
          tabIndex === 3 && (
            <div>
              <Header heading='Xero Details' />
              <div class="xeroTable" dangerouslySetInnerHTML={{__html: this.prettify(this.props.xeroSnapshot.bankTransfer) }} />
            </div>
          )
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const organisation = state.organisations[ownProps.organisationId];
  return { organisation }
};

const styled = withStyles(styles)(XeroDetails)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Applications/XeroDetails.js